import { FloraSupportedObjectTypes } from '../../flora.type';
import type { MentionType } from '../flora-mention/flora-mention.type';

const OBJECT_TYPE_TO_MENTION_TYPE: Partial<Record<FloraSupportedObjectTypes, MentionType>> = {
  [FloraSupportedObjectTypes.Portfolio]: 'portfolio',
  [FloraSupportedObjectTypes.Project]: 'project',
  [FloraSupportedObjectTypes.Subproject]: 'board',
  [FloraSupportedObjectTypes.Initiative]: 'initiative',
  [FloraSupportedObjectTypes.WorkPeriod]: 'sprint',
  [FloraSupportedObjectTypes.Objective]: 'outcome',
  [FloraSupportedObjectTypes.StrategicGoal]: 'goal',
  [FloraSupportedObjectTypes.Dashboard]: 'dashboard',
};

/**
 * Maps a FloraSupportedObjectTypes value to its corresponding MentionType for pill rendering.
 *
 * @param {FloraSupportedObjectTypes} type - The Flora object type to map
 * @returns {MentionType | null} The matching MentionType, or null if no mapping exists
 */
const mapObjectTypeToMentionType = (type: FloraSupportedObjectTypes): MentionType | null => {
  return OBJECT_TYPE_TO_MENTION_TYPE[type] ?? null;
};

export { mapObjectTypeToMentionType };
